const Theme = {
    colors: {
        darkMode: {
            primary: '#121212',
            Hover: '#2b2727',
            txt: '#fff',
        },

        lightMode: {
            primary: '#f9f9f9',
            secondary: 'fff',
            txt: '#000',
        }
    },

    fonts: {
        fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif",
        bolderSize: '800'
    }
}

export default Theme;